import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { AdminLegalPagesEditor } from "@/components/AdminLegalPagesEditor";
import { buildLegalPagesPayload } from "@/lib/legalPagesPayload";

const EMPTY_LEGAL = {
  operator: {},
  terms: { title: "", sections: [] },
  privacy: { title: "", sections: [] },
};

export function AdminLegalPagesConfig() {
  const [legalPages, setLegalPages] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const r = await api.get("/pricing-config");
      setLegalPages(r.data?.legal_pages || EMPTY_LEGAL);
    } catch (e) {
      const status = e.response?.status;
      toast.error(
        status === 404
          ? "API nem elérhető (404). Indítsd a backendet (pl. :8000)."
          : e.response?.data?.detail || "Jogi oldalak betöltése sikertelen",
      );
      setLegalPages(null);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const save = async (pageOverride) => {
    const legal_pages = buildLegalPagesPayload(pageOverride || legalPages);
    setSaving(true);
    try {
      const r = await api.patch("/admin/pricing-config", { legal_pages });
      setLegalPages(r.data.legal_pages || legal_pages);
      toast.success("ÁSZF és adatvédelem mentve");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Jogi oldalak mentése sikertelen");
    } finally {
      setSaving(false);
    }
  };

  if (!legalPages) {
    return (
      <div className="text-slate-400 text-sm space-y-2" data-testid="admin-legal-load-error">
        <p>Nem sikerült betölteni a jogi dokumentumokat.</p>
        <button type="button" onClick={load} className="text-electric hover:underline text-sm">
          Újrapróbálás
        </button>
      </div>
    );
  }

  return (
    <div data-testid="admin-legal-config" className="space-y-4">
      <p className="text-sm text-slate-400">
        A nyilvános oldalak:{" "}
        <a href="/aszf" target="_blank" rel="noreferrer" className="text-electric hover:underline">
          /aszf
        </a>
        {" · "}
        <a href="/adatvedelem" target="_blank" rel="noreferrer" className="text-electric hover:underline">
          /adatvedelem
        </a>
      </p>
      <AdminLegalPagesEditor
        legalPages={legalPages}
        onChange={setLegalPages}
        onSave={save}
        saving={saving}
      />
    </div>
  );
}
